import store from '@/store'
import { capitalize } from '@/helpers/string'

const isParkNCharge = process.env.VUE_APP_TENANT === 'park-n-charge'

export const assetValues = {
  history: '',
  historyReference: '',
  location: null,
  locationId: '',
  originalLocationId: '',
  chargerIds: '',
  chargerIds_satellite: '',
  coordinates: {},
  street: '',
  number: '',
  suffix: '',
  postalCode: '',
  city: '',
  municipality: '',
  streetAndNumber: '',
  numberOfChargingStations: 0,
  numberOfParkingSpots: 0,
  EAN: '',
  gridConnectionValue: '',
  gridOperator: '',
  gridOperatorNumber: '',
  gridOperatorAddress: {},
  dateActive: '',
  chargingStationVersion: '',
  domain: '',
  finUnit: null,
  processType: null,
  assetType: '',
  tenantAcronym: '',
  createddBy: {
    id: '',
    name: ''
  },
  updatedBy: {
    id: '',
    name: ''
  },
  editData: {
    coordinates: {
      latitude: '',
      longitude: ''
    },
    gridOperatorAddress: {},
    ChargerIds: []
  }
}

export const assetImportProps = {
  'Laadpaal ID principaal': 'chargerIds',
  'Laadpaal ID satelliet': 'chargerIds_satellite',
  'Locatienummer': 'originalLocationId',
  'Straat': 'street',
  'Huisnummer': 'number',
  'Huisnummer toevoeging': 'suffix',
  'Plaatsnaam': 'city',
  'Postcode': 'postalCode',
  'Gemeente': 'municipality',
  'Netbeheerder': 'gridOperator',
  ...( isParkNCharge ? { 'Kostenplaats': 'finUnit' } : {} ),
  'EAN Code': 'EAN',
  'EAN Straat': 'gridOperatorAddress',
  'EAN Huisnummer': 'gridOperatorAddress',
  'EAN Huisnummer toevoeging': 'gridOperatorAddress',
  'EAN Postcode': 'gridOperatorAddress',
  'EAN Plaats': 'gridOperatorAddress',
  'Aantal palen': 'numberOfChargingStations',
  'Aantal gereserveerdparkeervakken': 'numberOfParkingSpots',
  'Domein': 'domain',
  'Aansluitwaarde': 'gridConnectionValue',
  'Coordinaat principaal': 'coordinates'
}

export const SPV = {
  'Qwello-Infra-B.V.': 'Qwello Infra B.V.',
  'spv-evnet-nl': 'spv-evnet-nl',
  'friesland-bv': 'friesland-bv',
  'spv-b1': 'spv-b1',
  'spv001': 'SPV 1',
  'spv002': 'SPV 2',
  'spv003': 'SPV 3',
  'spv004': 'SPV 4',
  'spv005': 'SPV 5',
  'spv006': 'SPV 6',
  'spv007': 'SPV 7',
  'spv008': 'SPV 8',
  'spv009': 'SPV 9',
}

export const connectionValue = {
  '1x25A': '1 x 25 A',
  '1x35A': '1 x 35 A',
  '1x40A': '1 x 40 A',
  '3x25A': '3 x 25 A',
  '3x35A': '3 x 35 A',
  '3x50A': '3 x 50 A',
  '3x63A': '3 x 63 A',
  '3x80A': '3 x 80 A',
  '3x100A': '3 x 100 A',
  '3x125A': '3 x 125 A',
  '3x160A': '3 x 160 A',
  '3x250A': '3 x 250 A',
  '3x400A': '3 x 400 A',
  '3x500A': '3 x 500 A',
  '3x630A': '3 x 630 A',
  '160kVA': '160 kVA',
  '250kVA': '250 kVA',
  '400kVA': '400 kVA',
  '630kVA': '630 kVA',
  '1750kVA': '1750 kVA',
  '2000kVA': '2000 kVA'
}
 export const fn = {
  coordinates (record) {
    if (record.coordinates) {
      const [lat, lng] = record.coordinates.split(',')
      record.editData.coordinates.latitude = lat?.trim() || ''
      record.editData.coordinates.longitude = lng?.trim() || ''
      record.coordinates = record.editData.coordinates
    }
    return record
  },

  gridOperatorAddress (record, column, value) {
    const address = {
      'EAN Straat': 'StreetName',
      'EAN Huisnummer': 'HouseNumber',
      'EAN Huisnummer toevoeging': 'HouseNumberSuffix',
      'EAN Postcode': 'PostalCode',
      'EAN Plaats': 'CityName'
    }

    record.editData.gridOperatorAddress[address[column]] = value
    return record
  },

  finUnit (record) {
    if (record.finUnit && !SPV[record.finUnit]) {
      record.finUnit = 'Qwello-Infra-B.V.'
    }

    return record
  },

  domain (record) {
    record.domain = record.domain ? capitalize(record.domain) : 'Publiek'
    return record
  },

  chargerIds (record, chargerType) {
    const type = chargerType || 'principal'
    const prop = `chargerIds${chargerType ? '_satellite' : ''}`
    const ids = this.setChargerIds(record[prop], type)
    record.editData.ChargerIds = [...record.editData.ChargerIds || [], ...ids]
    return record
  },

  chargerIds_satellite (record) {
    return this.chargerIds(record, 'satellite')
  },

  gridConnectionValue (record) {
    if (record.gridConnectionValue) {
      record.gridConnectionValue = connectionValue[record.gridConnectionValue]
    }
    return record
  },

  municipality (record) {
    const municipality = store.getters['tenant/getAllMunicipalityOptions'].find(mun => mun.text === record.municipality)
    if (municipality && record.municipality) {
      record.municipality = municipality.value
    }
    return record
  },

  setChargerIds (ids, type) {
    return ids.split(',').map(id => {
      return {
        ChargerType: type,
        ChargerId: id.trim()
      }
    })
  },
 }
